import { PaymentsProcessor } from '@weave/schema-gen-ts/dist/schemas/payments-platform/payments-config/payments_config.pb';
import { useAlert } from '@weave/design-system';
import { paymentsFeatureFlags } from 'redux/actions/merchant';
import { useSelector } from 'react-redux';
import { selectFeatureFlag } from 'redux/actions/feature-flags';
import { useEffect } from 'react';
import { usePaymentsConfig } from 'apis/payments';

export const useProcessorType = (locationId: string | undefined) => {
  const alert = useAlert();
  const justifiOnboardingFF = useSelector((state) =>
    selectFeatureFlag(state, paymentsFeatureFlags.EnableJustifyOnboarding)
  );

  const { processor: processorType, isLoading, error } = usePaymentsConfig(locationId);

  useEffect(() => {
    if (error) {
      console.error('Error fetching payment processor:', error);
      alert.error('Error fetching payment processor');
    }
  }, [error]);

  const hasJustifiProcessor =
    processorType === PaymentsProcessor.PAYMENTS_PROCESSOR_JUSTIFI;
  const hasStripeProcessor =
    processorType === PaymentsProcessor.PAYMENTS_PROCESSOR_STRIPE;

  const isJustifiLocation = justifiOnboardingFF || hasJustifiProcessor;

  return {
    hasJustifiProcessor,
    hasStripeProcessor,
    isLoading,
    processorType,
    isJustifiLocation,
  };
};
